import React, { useMemo } from 'react';
import classNames from 'classnames';
import styles from './css/index.module.scss';
import DropdownIcon from '../../../../assets/icons/dropdownBottom.svg';
import useComponentVisible from '../../../../hooks/useComponentVisible';

function CompactSelect({
  items = [],
  value,
  onChange,
  placeholder,
  renderValue,
  width = 103,
  height = 36,
  dropdownHeight = 204,
  isDisabled,
  withBorder = true,
  className,
}) {
  const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible();

  const selectedItem = useMemo(() => items.find((item) => item.value === value), [items, value]);
  const isEmpty = value === null || value === undefined;
  const valueText = isEmpty ? '' : renderValue ? renderValue(selectedItem) : selectedItem?.label;

  const onItemClick = (item) => {
    onChange(item.value);
    setIsComponentVisible(false);
  };

  return (
    <div
      ref={ref}
      className={classNames(styles.select, 'noSelection', className)}
      style={{ width: typeof width === 'string' ? width : `${width}px` }}
    >
      <div
        className={classNames(styles.field, {
          [styles.fieldWithBorder]: withBorder,
          [styles.fieldOpened]: isComponentVisible,
          [styles.fieldDisabled]: isDisabled,
        })}
        style={{ height: `${height}px` }}
        onClick={isDisabled ? undefined : () => setIsComponentVisible((prev) => !prev)}
      >
        <p className={classNames(styles.value, { [styles.valuePlaceholder]: !valueText })}>
          {valueText || placeholder}
        </p>
        <img
          src={DropdownIcon}
          alt="V"
          className={classNames(styles.icon, { [styles.iconOpened]: isComponentVisible })}
        />
      </div>

      <div
        className={classNames(styles.list, { [styles.listVisible]: isComponentVisible })}
        style={{ maxHeight: `${dropdownHeight}px`, top: `${height + 6}px` }}
      >
        {items.map((item) => (
          <div
            key={item.value ?? 'empty'}
            className={classNames(styles.listItem, { [styles.listItemActive]: item.value === value })}
            onClick={() => onItemClick(item)}
          >
            <p className={styles.listItemText}>{item.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CompactSelect;
